import React from 'react';
import { Chip } from '@mui/material';
import { sessionModeLabel, sessionModeChipColor } from '../utils/sessionMode';

const SessionModeChip = ({ mode, size = 'small', sx, ...props }) => (
  <Chip
    label={sessionModeLabel(mode)}
    color={sessionModeChipColor(mode)}
    variant="outlined"
    size={size}
    sx={sx}
    {...props}
  />
);

export default SessionModeChip;
